'use strict';

import debounce from 'raf-throttle';
import ssm from 'simplestatemanager';

// export default function($){
console.log('this comes from nav-menu.js example');

const $cNavMain = $('.c-nav-main')


// Show/hide menu
$cNavMain
	.on('click touchstart', '.mobile-button-wrapper .navbar-toggle', function () {
		$('html').addClass("expanded-mobile-menu");
		return false;
	})
	.on('click touchstart', '.mobile-close-button-wrapper .navbar-toggle', function () {
		$('html').removeClass("expanded-mobile-menu");
		$('.c-nav-main #block-mainnavigation .open').removeClass('open');
		return false;
	})
	// expand/collapse menu levels
	.on('click', '.mega-menu__primary-item .mega-menu__primary-link:not(.no-child)', function (e) {
		// if($(window).outerWidth() <= 991){
		if (!!currSmall) {
			e.preventDefault();
			$(this).toggleClass("open");
		}
	})
	.on('click', '.mega-menu__primary-item .mega-menu__secondary-link:not(.no-child)', function (e) {
		// if($(window).outerWidth() <= 991){
		if (!!currSmall) {
			e.preventDefault();
			$(this).toggleClass("open");
		}
	})
	// Show/hide search
	.on('touchstart click', '.navbar-header .search-link-button > a, #block-mainnavigation .search-link-button > a', function () {
		$(this).closest('.search-link-button').toggleClass("show-search-menu");
		$('html').toggleClass('expanded-search-menu');
		$('.navbar-header .language-change-button').removeClass("show-country-menu");
		$('#block-mainnavigation .language-change-button').removeClass("show-country-menu");
		return false;
	})
// .on('mouseenter', '.mega-menu__primary-item', function(){
// 	$('.show-search-menu, .show-country-menu').removeClass('show-search-menu show-country-menu');
// })

// Set base sticky activation height
var stickyActivate = $('.c-nav-main__header-logo').outerHeight();

var stickyNav = debounce((function () {
	const windowScroll = $(window).scrollTop();

	const $showSearchMenu = $('.navbar-header .search-link-button.show-search-menu');
	const $showCountryMenu = $('.navbar-header .language-change-button.show-country-menu');
	const $inBlockSearchMenu = $('#block-mainnavigation .search-link-button.show-search-menu');
	const $inBlockCountryMenu = $('#block-mainnavigation .language-change-button.show-country-menu');


	// Sticky nav script
	if (windowScroll > stickyActivate) {
		$cNavMain.addClass('sticky-nav');

		if ($showSearchMenu.length > 0 && !currSmall) {
			$showSearchMenu.removeClass("show-search-menu");
		};
		if ($showCountryMenu.length > 0 && !currSmall) {
			$showCountryMenu.removeClass("show-country-menu");
		};
	} else if ((windowScroll <= stickyActivate) || ($(window).scrollTop() === 0)) {
		$cNavMain.removeClass('sticky-nav');

		// if ($('.c-nav-main').hasClass('sticky-nav')) {
		if ($inBlockSearchMenu.length > 0 && !currSmall) {
			$inBlockSearchMenu.removeClass("show-search-menu");
		};
		if ($inBlockCountryMenu.length > 0 && !currSmall) {
			$inBlockCountryMenu.removeClass("show-country-menu");
		};
		// }
	}
}), 2, true);

// Check for a scroll event and run the sticky nav
window.addEventListener('scroll', stickyNav);

$(document).ready(function () {
	stickyNav();
})

// if ($(window).outerWidth() > 991) {

// Check if loaded document needs a sticky nav, if scrolled or loading to a point low on page
$(document)

	// Show/hide change country
	.on('click', '.navbar-header .language-change-button > a, #block-mainnavigation .language-change-button > a', function () {
		if (!!currBig) {
			$(this).closest('.language-change-button').addClass("show-country-menu");
			$('.navbar-header .search-link-button').removeClass("show-search-menu");
			$('#block-mainnavigation .search-link-button').removeClass("show-search-menu");
		}
	})
	.on('click', '.navbar-header .language-change-button.show-country-menu > a, #block-mainnavigation .language-change-button.show-country-menu > a', function () {
		if (!!currBig) {
			$(this).closest('.language-change-button').removeClass("show-country-menu");
		}
	})
	.on('click', '.navbar-header .language-change-button .close-country-popup .navbar-toggle, #block-mainnavigation .language-change-button .close-country-popup .navbar-toggle', function () {
		if (!!currBig) {
			$(this).closest('.language-change-button').removeClass("show-country-menu");
		}
	})
	.on('click', '.navbar-header .search-link-button.show-search-menu > a, #block-mainnavigation .search-link-button.show-search-menu > a', function () {
		if (!!currBig) {
			$(this).closest('.search-link-button').removeClass("show-search-menu");
		}
	})
	.on('click', '.navbar-header .search-link-button .close-language-popup .navbar-toggle, #block-mainnavigation .search-link-button .close-language-popup .navbar-toggle', function () {
		if (!!currBig) {
			$(this).closest('.search-link-button').removeClass("show-search-menu");
			$('html').removeClass('expanded-search-menu');
		}
	});
// };



// If is mobile/tablet
// if ($(window).outerWidth() <= 991) {
// mobile menu functionality
$cNavMain
	// Show/hide change country
	.on('click', '.navbar-header .language-change-button > a, #block-mainnavigation .language-change-button > a', function () {
		if (!!currSmall) {
			$(this).closest('.language-change-button').addClass("show-country-menu");
			$('.navbar-header .search-link-button').removeClass("show-search-menu");
			$('#block-mainnavigation .search-link-button').removeClass("show-search-menu");
			$('html').addClass("expanded-country-menu");
		}
	})
	.on('click', '.navbar-header .language-change-button.show-country-menu > a, #block-mainnavigation .language-change-button.show-country-menu > a', function () {
		if (!!currSmall) {
			$(this).closest('.language-change-button').removeClass("show-country-menu");
			$('html').removeClass("expanded-country-menu");
		}
	})
	.on('click', '.navbar-header .language-change-button .close-country-popup .navbar-toggle, #block-mainnavigation .language-change-button .close-country-popup .navbar-toggle', function () {
		if (!!currSmall) {
			$(this).closest('.language-change-button').removeClass("show-country-menu");
			$('html').removeClass("expanded-country-menu");
		}
	})
	.on('click', '.navbar-header .search-link-button.show-search-menu > a, #block-mainnavigation .search-link-button.show-search-menu > a', function () {
		if (!!currSmall) {
			$(this).closest('.search-link-button').removeClass("show-search-menu");
		}
	})
	.on('click', '.navbar-header .search-link-button .close-language-popup .navbar-toggle, #block-mainnavigation .search-link-button .close-language-popup .navbar-toggle', function () {
		if (!!currSmall) {
			$(this).closest('.search-link-button').removeClass("show-search-menu");
			$('html').removeClass('expanded-search-menu');
		}
	});
	// };

// }



// WEBPACK FOOTER //
// ./src/_js/partials/nav-menu.js